import { render, staticRenderFns } from "./unquote-list.vue?vue&type=template&id=948021aa&scoped=true&"
import script from "./unquote-list.vue?vue&type=script&lang=js&"
export * from "./unquote-list.vue?vue&type=script&lang=js&"
import style0 from "./unquote-list.vue?vue&type=style&index=0&id=948021aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "948021aa",
  null
  
)

export default component.exports